import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../store"
import { useEffect } from "react"
import { candidateRetrieveTenant } from "../../scenes/company/job/CandidateJobAction"

interface TopbarProps {
    companyCode: string
}

const Topbar = (topbarProps: TopbarProps) => {
  const { companyCode } = topbarProps
  const dispatch = useDispatch<AppDispatch>()
  const { tenant } = useSelector((state: any) => state.candidateJob)

  useEffect(() => {
    // Load tenant information
    dispatch(candidateRetrieveTenant(companyCode))
  }, [companyCode])

  return (
    <div className="flex align-items-center justify-content-between px-4 py-2 surface-0" style={{ minHeight: "64px" }}>
      <div className="flex align-items-center gap-3">
        {tenant.logo && (
          <img
            src={tenant.logo}
            alt={`${tenant.companyName} logo`}
            className="border-circle"
            style={{ width: "40px", height: "40px", objectFit: "contain", background: "#fff" }}
          />
        )}
        <span className="text-2xl font-semibold">{tenant.companyName}</span>
      </div>
    </div>
  )
}

export default Topbar